import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BookingService from "../../services/booking.service";

// ================= THUNKS =================

export const getBookings = createAsyncThunk(
  "booking/getBookings",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.getBookings(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const getupcomingBookings = createAsyncThunk(
  "booking/getupcomingBookings",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.getupcomingBookings(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getCustomerPayments = createAsyncThunk(
  "booking/getCustomerPayments",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.getCustomerPayments(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getVendorPayments = createAsyncThunk(
  "booking/getVendorPayments",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.getVendorPayments(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addBooking = createAsyncThunk(
  "booking/addBooking",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.addBooking(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addCustomerPayment = createAsyncThunk(
  "booking/addCustomerPayment",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.addcustomerpayment(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addVendorPayment = createAsyncThunk(
  "booking/addVendorPayment",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.addvendorpayment(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const generateinvoice = createAsyncThunk(
  "booking/generateinvoice",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.generateinvoice(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getInvoice = createAsyncThunk(
  "booking/getInvoice",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.getInvoice(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const sendInvoice = createAsyncThunk(
  "booking/sendInvoice",
  async (data, thunkAPI) => {
    try {
      const res = await BookingService.sendInvoice(data);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// ================= INITIAL STATE =================

const initialState = {
  loading: false,
  error: null,
  bookingList: [],
  updateSuccess: false,
};

// ================= SLICE =================

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      // ===== GET BOOKINGS =====
      .addCase(getBookings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBookings.fulfilled, (state, action) => {
        state.loading = false;

        const payload = action.payload;

        //  Ensure always array
        state.bookingList = Array.isArray(payload?.data)
          ? payload.data
          : [];
      })
      .addCase(getBookings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ===== ADD BOOKING =====
      .addCase(addBooking.pending, (state) => {
        state.loading = true;
      })
      .addCase(addBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const newBooking = action.payload?.data;

        if (Array.isArray(state.bookingList) && newBooking) {
          state.bookingList.unshift(newBooking);
        }
      })
      .addCase(addBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ===== CUSTOMER PAYMENT =====
      .addCase(addCustomerPayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(addCustomerPayment.fulfilled, (state) => {
        state.loading = false;
        state.updateSuccess = true;
      })
      .addCase(addCustomerPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ===== VENDOR PAYMENT =====
      .addCase(addVendorPayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(addVendorPayment.fulfilled, (state) => {
        state.loading = false;
        state.updateSuccess = true;
      })
      .addCase(addVendorPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // ===== GET CUSTOMER PAYMENTS =====
      .addCase(getCustomerPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.customerPayments = action.payload?.data || [];
      })

      // ===== GET VENDOR PAYMENTS =====
      .addCase(getVendorPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.vendorPayments = action.payload?.data || [];
      });
  },
});

export const { resetUpdateStatus } = bookingSlice.actions;
export default bookingSlice.reducer;